// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoyPass_wrapper__lsnle","about":"RoyPass_about__2qjQY","text":"RoyPass_text__58Wgt"};